import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getInstrukturRpl = 'instruktur-rpl';
const getDetailInstrukturRpl = 'instruktur-rpl/';
const postInstrukturRplUrl = 'instruktur-rpl';
const putInstrukturRpl = 'instruktur-rpl/';
const deleteInstrukturRpl = 'instruktur-rpl/';

class InstrukturRplService {
    getInstrukturRpl(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getInstrukturRpl + '?pageNo=' + currentPage + '&pageSize='+pageSize+'&filter='+filter,
            {
                headers: authHeader()
            });
    }
    getDetailInstrukturRpl(idInstrukturRpl) {
        return axios.get(
            API_URL + getDetailInstrukturRpl + idInstrukturRpl,
            {
                headers: authHeader()
            });
    }
    
    getAll() {
        return axios.get(
            API_URL + getInstrukturRpl + '?pageNo=0&pageSize=100000&filter=default',
            {
                headers: authHeader()
            });
    }

    postInstrukturRpl(formData) {
        var form = new FormData();
        form.append("nama", formData.nama);
        form.append("alamat", formData.alamat);
        form.append("noTelephone", formData.noTelephone);
        form.append("email", formData.email);
        form.append("instansi", formData.instansi);
        if (typeof formData.cv !== 'undefined') {
            form.append('cv', formData.cv); 
        }
        form.append("npwp", formData.npwp);
        form.append("akunBank", formData.akunBank);
        form.append("status", "1");
        return axios
            .post(API_URL + postInstrukturRplUrl, form,
            {
                headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() }
            })
            .then(response => {
                return response.data.message;
            });
    }

    putInstrukturRpl(formData,idInstrukturRpl) {
        var headers = authHeader();
        var form = new FormData();
        form.append("nama", formData.nama);
        form.append("alamat", formData.alamat);
        form.append("noTelephone", formData.noTelephone);
        form.append("email", formData.email);
        form.append("instansi", formData.instansi);
        if (typeof formData.cv !== 'undefined') {
            form.append('cv', formData.cv); 
        }
        form.append("npwp", formData.npwp);
        form.append("akunBank", formData.akunBank);
        form.append("status", formData.status);

        return axios
            .put(
                API_URL + putInstrukturRpl + idInstrukturRpl, form,
                { 
                    headers: { 'Content-Type': 'multipart/form-data', 'Authorization' : tokenHeader() } 
                }
            );
    }

    deleteInstrukturRpl(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteInstrukturRpl + formData.idInstrukturRpl,
                { headers: authHeader() }
            );
    }

}

export default new InstrukturRplService();
